import { render, staticRenderFns } from "./ArchiveViewerHeader.vue?vue&type=template&id=0f38e136&scoped=true&"
import script from "./ArchiveViewerHeader.vue?vue&type=script&lang=js&"
export * from "./ArchiveViewerHeader.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveViewerHeader.vue?vue&type=style&index=0&id=0f38e136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f38e136",
  null
  
)

export default component.exports